import React from 'react';
import { useTranslation } from 'utils/modifiedTranslation';
import { useSetHeaderSettings } from 'components/PageHeader/PageHeaderContext';
import { VERSIONS } from 'components/PageHeader/constants';
import MaintenanceImg from './img/maintenance.png';
import './style.css';

const Maintenance = () => {
  const { t } = useTranslation();
  useSetHeaderSettings({
    version: VERSIONS.DEFAULT,
  });
  return (
    <div className="maintenance">
      <p>{t('maintenance.title')}</p>
      <img src={MaintenanceImg} alt="Maintenance" />
    </div>
  );
};

export default Maintenance;
